const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class PromiseOfMilitaryProtection extends Pact {
    constructor() {
        super(
            Age.Age2,
            PactNames.PromiseOfMilitaryProtection,
            "A produces an extra culture per round. B adds 4 to its military and produces 1 less culture per round. This pact ends if one attacks the other.",
            {}
        )
    }
}

module.exports = PromiseOfMilitaryProtection;